import t from "./ghl-ui.es1239.js";
function e() {
  this.__data__ = new t(), this.size = 0;
}
export {
  e as default
};
